require('./brokerTransferExternalSideBar.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ constants
const { FIRST_STEP,
        SECOND_STEP,
        BROKER_TYPE_BANK_NAME,
        BROKER_TYPE_AGENCIE
 } = require('constants/index');

class brokerTransferExternalSidebar extends React.Component {

    buildAccountBlock({ postfix, immTransferExternalValues, immTraspassFunds }) {
        const selectedOption = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);
        const immFunds =  immTraspassFunds.get('funds');
        const selectedAccount = immFunds.get(selectedOption);
        const key = `blockContract${selectedAccount.get('walletNumber')}`;
        const title = `broker-transferValuesSidebarSecondStepAccount${postfix}`;
        const plainAmountObject = getPlainAmountObject(selectedAccount.get('walletBalance'));

        return (
            <section key={key} className="broker-transfer-external-values-sidebar__section-light">
                <FormattedText value={title} />
                <div className="broker-transfer-external-values-sidebar__account-title">
                    {selectedAccount.get('walletAccountType')}
                </div>
                <div className="broker-transfer-values-sidebar__account-info">
                    <div className="broker-transfer-values-sidebar__account-number">
                        {selectedAccount.get('walletNumber')}
                    </div>
                    <div className="broker-transfer-values-sidebar__account-titular">
                        <FormattedText
                            value="broker-transferValuesSidebarSecondStepFirstTitular"
                            className="broker-transfer-values-sidebar__label"
                        />
                        {selectedAccount.get('firstTitular')} ({selectedAccount.get('firstTitularType')})
                    </div>
                    <div className="broker-transfer-values-sidebar__account-associated">
                        <FormattedText
                            value="broker-transferValuesSidebarSecondStepAssociatedAccount"
                            className="broker-transfer-values-sidebar__label"
                        />
                        {selectedAccount.get('associatedAccountAlias')}
                    </div>
                    <div>
                        <span>
                            <span className="broker-transfer-values-sidebar__label">
                                {selectedAccount.get('associatedAccount')}
                            </span>
                            (
                            <FormattedText
                                value="broker-transferValuesSidebarSecondStepBalance"
                                className="broker-transfer-values-sidebar__label"
                             />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                            )
                        </span>
                    </div>
                </div>
            </section>
        );
    }

    buildFirstStepSidebar() {
        const title = '';

        const contentHelp = (
            <div>
                <section key="transferExternalStep1" className="broker-transfer-external-values-sidebar__helpbox">
                    <section key="transferStep1" className="broker-transfer-external-values-sidebar__helptitle">
                        <FormattedText
                            value="broker-transferExternalSidebarFirstStepMessageTitle"
                        />
                    </section>
                    <section key="transferStep1_1" className="broker-transfer-external-values-sidebar__helpbody">
                        <FormattedText
                            value="broker-transferExternalSidebarFirstStepMessageBody"
                        />
                    </section>
                </section>
            </div>
        );

        const content = (
            <div>
                <div className="content-box__tooltip broker-transfer-external-values-sidebar__info-tooltip">
                    <i className="broker-market-trends__icon-info icon-informacion"></i>
                </div>
                <section key="transferExternalStep1" className="broker-transfer-external-values-sidebar__section-light-first">
                    <section key="transferStep1" className="broker-transfer-external-values-sidebar__paragraph">
                        <FormattedText
                            value="broker-transferExternalSidebarFirstStepMessage1"
                        />
                    </section>
                    <section key="transferStep1_1">
                        <FormattedText
                            value="broker-transferExternalSidebarFirstStepMessage2"
                        />
                    </section>
                </section>
            </div>
        );

        return {
            title,
            contentHelp,
            content
        }
    }

    buildSecondStepSidebar() {
        const { immTransferExternalValues, immTraspassFunds } = this.props;
        const contractTo = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);
        const title = formatText('broker-transferValuesSidebarSecondStepTitle');
        let content;

        if (contractTo != -1) {

            content = [
                this.buildTransferBlockType(immTransferExternalValues),
                this.buildAccountBlock({
                    postfix: 'To',
                    immTransferExternalValues: immTransferExternalValues,
                    immTraspassFunds: immTraspassFunds
                })
            ];
        }

        return {
            title,
            content
        }
    }

    buildThirdStepSidebar() {
        const block = this.buildSecondStepSidebar();
        const content = this.buildTransferValues();
        return {
            title: block.title,
            content: [
                block.content,
                content
            ]
        }
    }

    buildTransferBlockType(immTransferExternalValues) {
        const key = 'blockTransferType';
        //let agencieContract = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencieContract']);
        let selectedValue, selectedName, contractNumber;

        if ( immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']).get(BROKER_TYPE_BANK_NAME).get('value') ) {
            selectedName = formatText('broker-transferExternalBankOrBoxLabel');
        }

        if ( immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']).get(BROKER_TYPE_AGENCIE).get('value') ) {
            selectedName = formatText('broker-transferExternalAgencieLabel');
        }

        if ( immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']).get(BROKER_TYPE_BANK_NAME).get('value') ) {
            contractNumber = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'contractNumber']);
            selectedValue = contractNumber.get('bank') + ' ' +  contractNumber.get('office') + ' ' + contractNumber.get('dc') + ' ' + contractNumber.get('contract');
        }

        if ( immTransferExternalValues.getIn(['steps', FIRST_STEP, 'transferType']).get(BROKER_TYPE_AGENCIE).get('value') ) {
            selectedValue = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'agencieContract']);
        }

        return (
            <section key={key} className="broker-transfer-external-values-sidebar__section-light">
                <FormattedText value="broker-transferExternalSidebarSecondStepTransferType" />
                <div className="broker-transfer-external-values-sidebar__transfer-type">
                    {selectedName}
                </div>
                <span>
                    {selectedValue}
                </span>
            </section>
        );
    }

    buildTransferValues() {
        const { immTransferExternalValues } = this.props;
        const key = 'blockTransferValues';
        let valueName, tittleAmount;

        valueName =  immTransferExternalValues.getIn(['steps', SECOND_STEP, 'valueName']);
        tittleAmount =  immTransferExternalValues.getIn(['steps', SECOND_STEP, 'titleAmount']);


        return (
            <section key={key} className="broker-transfer-external-values-sidebar__section-light">
                <FormattedText value="broker-transferExternalSidebarSecondStepTransferValues" />
                <div className="broker-transfer-external-values-sidebar__transfer-type">
                    {valueName}
                </div>
                <div className="broker-transfer-values-sidebar">
                    {tittleAmount} {formatText('broker-transferExternalSuccessTitleLabel')}
                </div>
            </section>
        );
    }


    render () {
        const { immTransferExternalValues } = this.props;
        const currentStep = immTransferExternalValues.get('visibleStep');
        let block, content, className;

        switch (currentStep) {
            case 1:
                block = this.buildFirstStepSidebar();
                className = 'broker-transfer-external-values-sidebar__transfer-box';
                break;
            case 2:
                block = this.buildSecondStepSidebar();
                break;
            case 3:
                block = this.buildThirdStepSidebar();
                break;
        }

        content = (
            <div>
                <OKSectionBox
                    title={block.title}
                    className={className}
                >
                    {block.contentHelp}
                </OKSectionBox>
                <OKSectionBox
                    title={block.title}
                    className={className}
                >
                    {block.content}
                </OKSectionBox>
            </div>
        );

        return content;
    }
}

brokerTransferExternalSidebar.propTypes = {
    immTransferExternalValues: PropTypes.object.isRequired,
    immTraspassFunds: PropTypes.object.isRequired
}

module.exports = brokerTransferExternalSidebar;
